import { useEffect, useState, useCallback } from "react";

const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
export const PLATFORM = /iphone|ipad|ipod/i.test(ua) || (/macintosh/i.test(ua) && typeof navigator !== "undefined" && navigator.maxTouchPoints > 1)
  ? "ios"
  : /android/i.test(ua) ? "android" : "desktop";

// Handles the PWA install prompt across desktop & mobile browsers.
export function usePWAInstall() {
  const [deferred, setDeferred] = useState(typeof window !== "undefined" ? window.__fhapasInstallPrompt || null : null);
  const [installed, setInstalled] = useState(
    typeof window !== "undefined" && (window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true)
  );
  const [dismissed, setDismissed] = useState(
    typeof window !== "undefined" && localStorage.getItem("fhapas_install_dismissed") === "1"
  );
  const [helpOpen, setHelpOpen] = useState(false);

  useEffect(() => {
    const onAvail = () => setDeferred(window.__fhapasInstallPrompt || null);
    const onInstalled = () => { setInstalled(true); setDeferred(null); };
    window.addEventListener("fhapas-install-available", onAvail);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("fhapas-install-available", onAvail);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const promptInstall = useCallback(async () => {
    if (!deferred) return false;
    deferred.prompt();
    const res = await deferred.userChoice;
    window.__fhapasInstallPrompt = null;
    setDeferred(null);
    return res?.outcome === "accepted";
  }, [deferred]);

  // One-tap install where the browser supports it; otherwise show platform steps.
  const install = useCallback(async () => {
    if (deferred) return promptInstall();
    setHelpOpen(true);
    return false;
  }, [deferred, promptInstall]);

  const dismiss = useCallback(() => {
    localStorage.setItem("fhapas_install_dismissed", "1");
    setDismissed(true);
  }, []);

  return {
    canInstall: !!deferred, installed, dismissed, promptInstall, install, dismiss,
    isIOS: PLATFORM === "ios", platform: PLATFORM, helpOpen, setHelpOpen,
  };
}
